(() => {
  const loader = document.querySelector('[data-veloura-loader]');
  if (!loader) return;

  const hide = () => {
    loader.hidden = true;
  };
  const reveal = () => {
    loader.classList.add('is-ready');
    window.setTimeout(hide, 320);
  };

  try {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const seen = window.sessionStorage.getItem('veloura-intro-seen');
    if (reduceMotion || seen) {
      hide();
      return;
    }
    window.sessionStorage.setItem('veloura-intro-seen', '1');
  } catch (_error) {
    hide();
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }

  // The intro is decorative and must never block shopping.
  window.setTimeout(reveal, 900);
})();